module.exports = __webpack_public_path__ + "img/19_9.a9464611.png";